<script>
    import TheSvgIcon from "@main/packages/TheSvgIcon";

    export default {
        name: "SelectCity",
        components: {
            TheSvgIcon,
        },
        props: {
            city: String,
        },
        computed: {
            showCityLimiter() {
                return this.city.length > 20;
            },
        },
    };
</script>

<template>
    <button
        class="select-city outline"
        :class="{ 'is-limiter': showCityLimiter }"
        @click="$popup.show('modal-select-city', { city })"
    >
        <the-svg-icon name="geo" class="select-city__ico" :size-w="24"></the-svg-icon>
        <span class="select-city__title">{{ city }}</span>
    </button>
</template>
